import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ef1e9564"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "select-block"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  slot: "empty"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_w_label = _resolveComponent("w-label");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.fieldLabel ? (_openBlock(), _createBlock(_component_w_label, {
    key: 0
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.fieldLabel), 1)]),
    _: 1
  })) : _createCommentVNode("", true), _createVNode(_component_el_select, {
    modelValue: _ctx.currentValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.currentValue = $event),
    name: _ctx.name,
    placeholder: _ctx.placeholder,
    size: _ctx.size,
    disabled: _ctx.disabled,
    style: _normalizeStyle(`width:${_ctx.width};`),
    onChange: _ctx.onInputChanges
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: item.value,
        label: item.label,
        value: item.value
      }, null, 8, ["label", "value"]);
    }), 128)), _renderSlot(_ctx.$slots, "default", {}, undefined, true), _hoisted_2]),
    _: 3
  }, 8, ["modelValue", "name", "placeholder", "size", "disabled", "style", "onChange"])]);
}